import { CovidTestSampleMethod, InterventionExternalCode } from 'ts-types/api.enums';
import { InterventionDto } from "ts-types/api.types";

export const interventionDescription = (intervention: InterventionDto | undefined, language: string): string => {

  if (!intervention) {
    return "";
  }

  const texts: { [key: string]: string } = {
    "de": intervention.description,
    "en": intervention.descriptionEn,
    "fr": intervention.descriptionFr,
    "it": intervention.descriptionIt
  };
  return texts[language] || intervention.description;
};

const stdExternalCodes = [
  InterventionExternalCode.HPV_TEST,
  InterventionExternalCode.CHLAMYDIA_TEST,
  InterventionExternalCode.TRICHOMONIASIS_TEST
];

export const isStdTestPanel = (externalCode: InterventionExternalCode | undefined): boolean => {
  return !!externalCode && stdExternalCodes.includes(externalCode);
}

const bloodExternalCodes = [
  InterventionExternalCode.HEPATITIS_B_TEST,
  InterventionExternalCode.QUANTITY_TEST,
  InterventionExternalCode.ORDER_ITEM_TEST
];

const orderItemCodes = [
  InterventionExternalCode.ORDER_ITEM_TEST
];

export const isBloodTest = (externalCode: InterventionExternalCode | undefined): boolean => {
  return !!externalCode && bloodExternalCodes.includes(externalCode)
};

export const isOrderItemTest = (externalCode: InterventionExternalCode | undefined): boolean => {
  return !!externalCode && orderItemCodes.includes(externalCode)
};

const testPanelCodes = [
  InterventionExternalCode.HPV_TEST,
  InterventionExternalCode.CHLAMYDIA_TEST,
  InterventionExternalCode.TRICHOMONIASIS_TEST,
  InterventionExternalCode.RSV_TEST,
  InterventionExternalCode.INFLUENZA_TEST,
  InterventionExternalCode.HEPATITIS_B_TEST,
  InterventionExternalCode.QUANTITY_TEST,
  InterventionExternalCode.ORDER_ITEM_TEST
];

const labTestCodes = [
  InterventionExternalCode.PCR_SALIVA_TEST,
  InterventionExternalCode.PCR_SALIVA_TEST_INDIVIDUAL_TEST,
  ...testPanelCodes
]

const optionalTestKitCodes = [
  InterventionExternalCode.ORDER_ITEM_TEST
];

export const isTestPanel = (externalCode: InterventionExternalCode): boolean => {
  return externalCode && testPanelCodes.includes(externalCode);
}

export const isLabTest = (externalCode: InterventionExternalCode): boolean => {
  return externalCode && labTestCodes.includes(externalCode);
}

export const isTestKitCodeOptional = (externalCode: InterventionExternalCode): boolean => {
  return externalCode && optionalTestKitCodes.includes(externalCode);
}

export const getSampleMethods = (externalCode: InterventionExternalCode): CovidTestSampleMethod[] => {

  let sampleMethods = [
    CovidTestSampleMethod.NASAL_SWAB,
    CovidTestSampleMethod.THROAT_SWAB,
    CovidTestSampleMethod.SALIVA
  ];

  const stdTestPanel = isStdTestPanel(externalCode);
  if (stdTestPanel) {
    sampleMethods = [CovidTestSampleMethod.VAGINAL_SWAB, CovidTestSampleMethod.URINE];
    return sampleMethods;
  }

  if (isBloodTest(externalCode)) {
    sampleMethods = [CovidTestSampleMethod.BLOOD_SERUM];
  }

  if (isOrderItemTest(externalCode)) {
    sampleMethods = [
      CovidTestSampleMethod.BLOOD_SERUM,
      CovidTestSampleMethod.VAGINAL_SWAB,
      CovidTestSampleMethod.URINE
    ];
  }

  return sampleMethods;
}
